import hexToRgb from 'hex-rgb';

export default (color, withAlpha = false) => {
	const { red, green, blue, alpha } = hexToRgb(color);
	return withAlpha ? `${red}, ${green}, ${blue}, ${alpha}` : `${red}, ${green}, ${blue}`;
};
